import React, { Component } from "react";
import { Container, FormControl, Row, Col, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import CreatableSelect from "react-select/creatable";
import '../../../assets/css/modal-dialogs.css';
import "../../../assets/css/modals.css";
import Resizer from "react-image-file-resizer";
import DocViewer, { DocViewerRenderers} from "@cyntler/react-doc-viewer";

import LocalImageDbService from "../../../services/LocalImageDbService";
import LocalDocumentDbService from "../../../services/LocalDocumentDbService";
import CoreService from "../../../services/CoreService";
import BlobStorageService from "../../../services/BlobStorageService";
import IdentityService from "../../../services/IdentityService";


const components = {
  DropdownIndicator: null
};


const createOption = (label) => ({
  label,
  value: label,
});

/*
export const UsingRef = () => {
  const docViewerRef = useRef<DocViewerRef>(null);
}
*/

const getUrlExtension = (url) => {
  return url
    .split(/[#?]/)[0]
    .split(".")
    .pop()
    .trim();
}

  //Here is code for converting "Base64" to javascript "File Object".***
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
    u8arr[n] = bstr.charCodeAt(n);
    }
  return new File([u8arr], filename, {type:mime});
 }


// if we have a file, great. But we may have a blob. We may need to convert blob to file. 
const resizeFile = (file, maxWidth, maxHeight, compressFormat, quality, rotation, outputType) => //, minWidth, minHeight) =>
new Promise((resolve) => {
  Resizer.imageFileResizer(
    file,
    maxWidth?? 300,
    maxHeight?? 300,
    compressFormat?? "JPEG",
    quality?? 100,
    rotation?? 0,
    (uri) => {
      resolve(uri);
    },
    outputType?? "base64"
  );
});


export default class UserFileModal extends Component 
{
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      value: [],
      descript: "",
      dataUri: null,
      files: [],
      fileAttribs: [],
      activeFile: null,
      fileIdx: -1,
      defaultTag: ""
    };


    this.viewerDivElement = null;
    this.viewerElement = null;

    this.setViewerDivElement = (element) => 
    {
      if (element)
      {
        this.viewerDivElement = element;
      }
    }

    this.setViewerElement = element => {
      console.log("Viewer Element Id is: " + element?.id);
      if (element?.id)
      {
        this.viewerElement = element;
        var allChildren = element.children;
        var inputs = document.getElementsByTagName('canvas');
        if (inputs)
        {
          var canvasCount = inputs.length;
          console.log("Canvas Count: " + canvasCount);
        }
      }
    };

    this.viewerRef = React.createRef
 

    this.localDocumentDbService = new LocalDocumentDbService();
    this.localImageDbService = new LocalImageDbService();
    this.blobStorageService = new BlobStorageService();
    this.coreService = new CoreService();

    this.handleDocumentChange = this.handleDocumentChange.bind(this);
    this.handleDescriptChange = this.handleDescriptChange.bind(this);
    this.onCloseDialog = this.onCloseDialog.bind(this);

    this.onFileUpload = this.onFileUpload.bind(this);
    this.onDeleteFileRequest = this.onDeleteFileRequest.bind(this);
    this.onSave = this.onSave.bind(this);

  }


  componentDidUpdate(prevProps) {
    if (prevProps.cardId !== this.props.cardId) {
      this.setState({
        defaultValue: [createOption(this.props.cardId)]
      })
    }

    
  }



  fileToUri = async (url) => {
    var b64 = await this.getBase64FromUrl(url);
    var result = this.b64toBlob(b64);
    return result;
  }

  getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  handleDocumentChange(document)
  {
    console.info(document);
    // find the document in files array by the "original" uri
    var fileIdx = this.state.files.findIndex(f => f.original === document.uri);
    this.setState({fileIdx: fileIdx, activeFile: document});

  }



  handleDescriptChange(ev) {
    ev.stopPropagation();
    if (this.state.fileIdx < 0) return;
    var newFileAttribs = this.state.fileAttribs;
    newFileAttribs[this.state.fileIdx].descript = ev.target.value;
    this.setState({
      descript: ev.target.value,
      fileAttribs: newFileAttribs
    });
    //this.props.onValueChange(this.Id, ev.target.value);

  }


  async onFileUpload(e) {
    e.stopPropagation()
    console.log(e.target.files);
    var newFiles = this.state.files;
    var newFileAttribs = this.state.fileAttribs;
    for (var i = 0; i < e.target.files.length; i++) {
      if ((e.target) && (e.target.files[i])) {
        var imgUrl = URL.createObjectURL(e.target.files[i]);
        var ext = e.target.files[i].type.split("/")[1];
        var name = e.target.files[i].name;
        var lastModified = e.target.files[i].lastModified;
        //var dataUri = await this.getBase64FromUrl(imgUrl);

        if (this.state.files.length === 0) {
          this.setState({ fileIdx: 0 });
        }
        newFiles.push({ "original": imgUrl});
        newFileAttribs.push({ "descript": name, "ext": ext, "inputValue": "", "value": this.state.defaultValue, "type": "file", "name": name, "lastModified": lastModified });
      }
    }
    var newFileIdx = newFiles.length-1;
    this.setState({
      files: newFiles,
      fileIdx: newFileIdx,
      fileAttribs: newFileAttribs
    });

    
  }

  onDeleteFileRequest()
  {
    if (this.state.fileIdx === -1) return;
    var newFiles = this.state.files;
    var newFileAttribs = this.state.fileAttribs;
    newFiles.splice(this.state.fileIdx, 1);
    newFileAttribs.splice(this.state.fileIdx, 1);
    var newFileIdx = (newFiles.length === 0) ? -1 :
      (this.state.fileIdx > newFiles.length - 1) ? newFiles.length - 1 : this.state.fileIdx;
    this.setState({
      files: newFiles,
      fileAttribs: newFileAttribs,
      fileIdx: newFileIdx
    });
    if (newFileIdx > -1)
    {
      // this is how you move to the proper index.
      // this.setState({activeDocument: newFiles[newFileIdx]});
      //this.imageGalleryRef.current.slideToIndex(newSlideIdx);
    }
  }



  async onSave() 
  {
    // TBD - we really want to do this for EACH file
    var viewerDiv = this.viewerDivElement;
    var canvasElements = viewerDiv.getElementsByClassName('react-pdf__Page__canvas');
    var canvasElement = canvasElements[0];
    var fullDataUrl = canvasElement.toDataURL();
    var tempFileName = IdentityService.makeUuid();
    var dataFile = dataURLtoFile(fullDataUrl, tempFileName + ".png");
    var thumbUri = await resizeFile(dataFile, 300, 300, 'png');

    for (var i = 0; i < this.state.files.length; i++) {
      var fl = this.state.files[i];
      var attrib = this.state.fileAttribs[i];
      var dataUri = (attrib.type === "file") ? await this.getBase64FromUrl(fl.original) : fl.original;
      var ky = IdentityService.makeUuid() + "-doc";
      var thumbKy = ky + "-thumb";
      var val = { id: ky, ext: attrib.ext, descript: attrib.descript, tags: attrib.value, dataUri: dataUri, name: attrib.name, lastModified: attrib.lastModified, 
        thumbnailId: thumbKy, thumbnailExt: 'png', thumbnailUri: thumbUri
     };
      //this.auth.setKey(ky, JSON.stringify(val));
      var saveResult = await this.onSaveFile(val);
    }

    this.onCloseDialog();
  }


  async onSaveFile(flObj) 
  {
    // does valuebag already have an images node?
    var newValueBag = this.props.valueBag;
    if (this.props.cardId === "completedloadfile") {
      newValueBag["completedloadfile"] = true;
    }
    let fl = { "id": flObj.id, "ext": flObj.ext, "descript": flObj.descript, "tags": flObj.tags, name: flObj.name, lastModified: flObj.lastModified, 
      thumbnailId: flObj.thumbnailId, thumbnailExt: flObj.thumbnailExt, thumbnailUri: flObj.thumbnailUri, "colspan": 1 };
    if (!newValueBag["userdocs"]) {
      // don't save the actual base64 data. TBD - we are going to save the image to either local storage for
      // upload or directly to Azure. 
      newValueBag["userdocs"] = [fl];
    }
    else {
      newValueBag["userdocs"].push(fl);
    }
    this.setState({ valueBag: newValueBag });

    //this.auth.saveLocalSuspendedObservation(this.state.valueBag.gcid, this.state.schemaId, this.state.valueBag.inspector, newValueBag);
    
    // we're going to PUSH a new card into the images group
    // and hope it re-renders!
        // we're going to PUSH a new card into the images group
    // and hope it re-renders!
    this.props.onInsertSchemaCard("notes", "Documents",
      {
        "id": fl.id, "title": "user file", "fieldType": "userdoc", "disallowToggle": true, "arrayValue": true, "parentId": "userdocs", "multiValueType": "array", "descript": fl.descript ?? "",
        "tags": fl.tags ?? [], "dataUri": flObj.dataUri, 
        thumbnailId: fl.thumbnailId, thumbnailExt: fl.thumbnailExt, thumbnailUri: fl.thumbnailUri
      });


      var docSaveResult = this.localDocumentDbService.addDocument(this.props.gcid, flObj.dataUri, fl.id);
      if ((await docSaveResult).hasError) return docSaveResult;
      var thumbSaveResult = this.localImageDbService.addImage(this.props.gcid, fl.thumbnailUri, fl.thumbnailId);
      return thumbSaveResult;

      /*
      var sasUriResponse = await this.coreService.fetchUserDocSasUri(fl.id, fl.ext, this.props.gcid, this.props.token);
      var sasUri = sasUriResponse.dataResult;
      var uploadResult = await this.blobStorageService.uploadUserImage(flObj.dataUri, sasUri)
      // upload Thumbnail
      var sasThumbUriResponse = await this.coreService.fetchUserImgSasUri(fl.thumbnailId, fl.thumbnailExt, this.props.gcid, this.props.token);
      var sasThumbUri = sasThumbUriResponse.dataResult;
      var thumbUploadResult = await this.blobStorageService.uploadUserImage(flObj.thumbnailUri, sasThumbUri);
    // TBD - error handling?
    // this.localDbImageService.addImage(imgObj.dataUri, imgObj.id);
    return new ServiceResponse(uploadResult.hasError, uploadResult.messages);
    */
  }



  onCloseDialog() {
    this.setState({
      dataUri: null,
      descript: "",
      value: [],
      inputValue: "",
    });
    this.props.onRequestClose(false);
  }

  render() {

    const { inputValue, value } = this.state;





      const attribBox = (this.state.fileIdx > -1) ? 
      <div>
        <Row style={{ marginTop: "5px" }}>
          <Col>
            <FormControl id="DescriptTextBox"
              autoFocus
              textAlign="left"
              placeholder="Comments..."
              aria-describedby="basic-addon2"
              name="imageDescription"
              value={this.state.files[this.state.fileIdx].descript}
              onChange={(e) => this.handleDescriptChange(e)}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "5px" }}>
          <Col>
            <CreatableSelect
              components={components}
              inputValue={inputValue}
              isClearable
              isMulti
              menuIsOpen={false}
              onChange={this.handleChange}
              onInputChange={this.handleInputChange}
              onKeyDown={this.handleKeyDown}
              placeholder="Optionally type a tag and press enter..."
              value={value}
            />
          </Col>

        </Row>
        <Row style={{ marginTop: "5px", justifyContent: "space-evenly" }}>

        </Row>
      </div> 
      : <span/>


    return (
      <Modal
        show={this.props.show}
        onHide={this.onCloseDialog}
      >
        <Modal.Header closeButton>
          <Modal.Title>User Documents - {this.props.cardId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container >
            <div id="viewerDiv" ref={this.setViewerDivElement}>
            <DocViewer
              ref = {this.setViewerElement}
              documents={this.state.files.map((f) => {return {uri: f.original}})}
              pluginRenderers={DocViewerRenderers}
              activeDocument={this.state.activeFile}
              onDocumentChange={this.handleDocumentChange}
            /> 
            </div>
          </Container>
        </Modal.Body>

        <Modal.Footer id="cam-modal-footer">
        <span>
            <Button id="cam-upload-button">
              <input type="file" id="files" style={{ display: "none" }} accept="application/pdf,application/vnd.ms-excel" multiple="true" onChange={(e) => this.onFileUpload(e)}></input>
              <label classname={"icon-circle"} for="files"><FontAwesomeIcon id="fileMode" icon={faUpload} />~Upload</label>
            </Button>
            <Button id="cam-delete-button" variant="secondary" disabled={(this.state.files.length < 1)} onClick={(ev) => this.onDeleteFileRequest()}>Delete Doc</Button>

          </span>

          <span id="cam-save-buttongroup">
            <Button id="cam-save-button" variant="secondary" disabled={(this.state.files.length < 1)} onClick={(ev) => this.onSave()}>Save</Button>
            <Button id="cam-cancel-button" variant="secondary" onClick={this.onCloseDialog}>Cancel</Button>

          </span>

        </Modal.Footer>
      </Modal>
    );
  }
}
